import type { IconAsset } from '../Icon.types';

const code = (
  <>
    <rect fill='none' height='24' width='24' />
    <g transform='translate(-655.682 -401.719)'>
      <path
        d='M677.319,413.789h0a10.044,10.044,0,0,0-12.535-5.742l.948,1.027a8.718,8.718,0,0,1,10.21,4.715,8.76,8.76,0,0,1-2.785,3.328l.866.938a10.045,10.045,0,0,0,3.3-4.265h0Z'
        fill='currentColor'
      />
      <path
        d='M674.023,418.3a.25.25,0,0,1-.184-.08l-.866-.938a.25.25,0,0,1,.037-.372,8.574,8.574,0,0,0,2.655-3.126,8.467,8.467,0,0,0-9.867-4.474.25.25,0,0,1-.249-.072l-.948-1.027a.25.25,0,0,1,.1-.406,10.289,10.289,0,0,1,12.847,5.885.249.249,0,0,1,.018.094.256.256,0,0,1-.018.095,10.3,10.3,0,0,1-3.378,4.371A.249.249,0,0,1,674.023,418.3Zm-.495-1.154.523.567a9.8,9.8,0,0,0,3-3.928,9.79,9.79,0,0,0-11.815-5.623l.58.628a8.931,8.931,0,0,1,2.188-.282,9.043,9.043,0,0,1,8.166,5.17.25.25,0,0,1,0,.214A9.033,9.033,0,0,1,673.528,417.151Z'
        fill='currentColor'
      />
      <path
        d='M671.14,414.932A3.323,3.323,0,0,0,668,410.438h0a3.324,3.324,0,0,0-.886.133l1.047,1.136a2.093,2.093,0,0,1,1.934,2.083v.01Z'
        fill='currentColor'
      />
      <path
        d='M671.14,415.182a.25.25,0,0,1-.184-.08l-1.045-1.132a.25.25,0,0,1-.065-.192,1.832,1.832,0,0,0-1.7-1.821.25.25,0,0,1-.164-.08l-1.047-1.136a.25.25,0,0,1,.118-.41,3.533,3.533,0,0,1,.952-.142,3.606,3.606,0,0,1,3.6,3.6,3.55,3.55,0,0,1-.228,1.227.25.25,0,0,1-.235.165Zm-.8-1.48.682.739a2.856,2.856,0,0,0,.076-.651,3.106,3.106,0,0,0-3.1-3.1,2.593,2.593,0,0,0-.408.033l.688.747a2.352,2.352,0,0,1,1.435.728A2.323,2.323,0,0,1,670.344,413.7Z'
        fill='currentColor'
      />
      <path
        d='M661.523,407.946l1.067,1.156a10.03,10.03,0,0,0-3.908,4.687h0a10.05,10.05,0,0,0,13.083,5.553c.066-.027.126-.065.192-.094l1.566,1.7.956-.882-12-13ZM668,418.817a8.791,8.791,0,0,1-7.94-5.027h0a8.783,8.783,0,0,1,3.394-3.749l1.771,1.919a3.26,3.26,0,0,0-.579,1.83A3.352,3.352,0,0,0,668,417.142a3.279,3.279,0,0,0,1.609-.436l1.428,1.548A8.628,8.628,0,0,1,668,418.817Zm.717-3.078a2.034,2.034,0,0,1-.721.141,2.1,2.1,0,0,1-2.09-2.1,2.046,2.046,0,0,1,.2-.867Z'
        fill='currentColor'
      />
      <path
        d='M662.479,406.814a.249.249,0,0,1,.184.08l12,13a.25.25,0,0,1-.014.353l-.956.882a.25.25,0,0,1-.353-.014l-1.439-1.559-.041.018a10.3,10.3,0,0,1-13.409-5.691.25.25,0,0,1-.018-.094.256.256,0,0,1,.018-.095,10.22,10.22,0,0,1,3.756-4.64l-.867-.94a.25.25,0,0,1,.014-.353l.956-.882A.249.249,0,0,1,662.479,406.814Zm11.647,13.236-11.661-12.633-.589.543.9.972a.25.25,0,0,1-.049.38,9.735,9.735,0,0,0-3.773,4.477,9.792,9.792,0,0,0,12.719,5.322c.024-.01.051-.024.081-.04s.066-.035.1-.051a.25.25,0,0,1,.284.059l1.4,1.513Zm-10.669-10.259a.25.25,0,0,1,.184.08l1.771,1.919a.25.25,0,0,1,.024.309,2.99,2.99,0,0,0-.536,1.69,3.105,3.105,0,0,0,3.1,3.1,3.022,3.022,0,0,0,1.487-.4.25.25,0,0,1,.306.049l1.428,1.548a.25.25,0,0,1-.1.4,8.869,8.869,0,0,1-3.126.579,9.041,9.041,0,0,1-8.166-5.17.25.25,0,0,1,.015-.241l0-.006a9.02,9.02,0,0,1,3.475-3.823A.249.249,0,0,1,663.457,409.791Zm1.457,2.2-1.5-1.626a8.515,8.515,0,0,0-3.074,3.431A8.541,8.541,0,0,0,668,418.567a8.319,8.319,0,0,0,2.6-.422l-1.04-1.128a3.472,3.472,0,0,1-1.556.375,3.606,3.606,0,0,1-3.6-3.6A3.5,3.5,0,0,1,664.914,411.988Zm1.194.675a.25.25,0,0,1,.184.08l2.609,2.826a.25.25,0,0,1-.1.4,2.271,2.271,0,0,1-.809.157h0a2.348,2.348,0,0,1-2.339-2.351,2.294,2.294,0,0,1,.226-.973.25.25,0,0,1,.226-.144Zm2.148,2.945-2.051-2.222a1.7,1.7,0,0,0-.048.395A1.847,1.847,0,0,0,668,415.63,1.565,1.565,0,0,0,668.256,415.608Z'
        fill='currentColor'
      />
    </g>
  </>
);

export const eyeClosed: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
